import * as api from 'registration/resources/registration.api';
import template from './confirm-registration.html';

// eslint-disable-next-line no-undef
@Inject('$stateParams')
class SelfRegistrationConfirmController {
  async $onInit() {
    this.loaded = false;
    this.response = await api.activateAccount(this.$stateParams.token);
    this.loaded = true;
  }
}

export default class SelfRegistrationConfirmComponent {
  constructor() {
    this.template = template;
    this.controller = SelfRegistrationConfirmController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/registration/components/self-registration/confirm-registration/confirm-registration-component.js